//@ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  preferencesUserRequest,
  preferencesUserSuccess,
  preferencesUserFailure,
} from '../reducer/preferencesUserSlice';
import { preferencesUserStatus } from '../api'; // Assuming API paths are correct

interface PreferencesUserAction {
  type: typeof preferencesUserRequest.type;
}

// Fetch Preferences User saga
export function* fetchPreferencesUserRequestSaga(
  action: PreferencesUserAction
): Generator<any, void, unknown> {
  try {
    const preferencesUser: any = yield call(
      preferencesUserStatus,
      'preferences_user',
      action.payload
    );

    console.log('preferencesUser>>>>>', preferencesUser);

    // If the API response has the Preferences User under `data`, modify the structure accordingly.
    if (preferencesUser?.statusCode === '200') {
      yield put(preferencesUserSuccess(preferencesUser)); // Assuming API response has a `status` field
    } else {
     
      yield put(preferencesUserFailure(preferencesUser));
    }
  } catch (error: any) {
    
    // yield put(
    //   preferencesUserFailure(
    //     {
    //       status: error?.status,
    //       title: error?.title ?? "",
    //       detail: error?.detail ?? ""
    //     }
    //     // error.message || 'Failed to fetch two factor code status.'
    //   )
    // );
  }
}

// Watch Preferences User sagas
export function* watchPreferencesUserSagas(): Generator<any, void, unknown> {
  yield takeLatest(
    preferencesUserRequest.type,
    fetchPreferencesUserRequestSaga
  );
}
